<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons slot="start">
                <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Corporate Manage User</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <Corporate />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
// @ is an alias to /src
import Corporate from "@/components/corporate/corporateManage.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from "@ionic/vue";

export default defineComponent ({
    name: 'corporateManage',
    components: {
        Corporate, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>